"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dropdown = exports.DropdownToggle = void 0;
var React = __importStar(require("react"));
var lodash_1 = require("lodash");
var styled_components_1 = __importDefault(require("styled-components"));
var DropdownMenu_1 = require("./DropdownMenu");
var Container = styled_components_1.default.div.attrs({
    className: 'tws-dropdown-container',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: relative;\n\toutline: none;\n\tdisplay: inline-block;\n\tcolor: #444444;\n"], ["\n\tposition: relative;\n\toutline: none;\n\tdisplay: inline-block;\n\tcolor: #444444;\n"])));
exports.DropdownToggle = styled_components_1.default.div.attrs({
    className: 'tws-dropdown-toggle',
    role: 'button',
    'aria-label': 'Dropdown Toggle',
})(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
exports.DropdownToggle.displayName = 'DropdownToggle';
var Dropdown = /** @class */ (function (_super) {
    __extends(Dropdown, _super);
    function Dropdown(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            open: false,
        };
        _this.handleOnBlur = _this.handleOnBlur.bind(_this);
        _this.toggleDropdownMenu = _this.toggleDropdownMenu.bind(_this);
        _this.dropdownRef = React.createRef();
        return _this;
    }
    Dropdown.prototype.render = function () {
        var _this = this;
        var children = React.Children.map(this.props.children, function (child) {
            if (child) {
                if (child.type === exports.DropdownToggle) {
                    return React.cloneElement(child, __assign({ onClick: _this.toggleDropdownMenu }, child.props));
                }
                else if (child.type === DropdownMenu_1.DropdownMenu) {
                    return React.cloneElement(child, __assign(__assign({}, (0, lodash_1.omit)(child.props, ['open'])), { open: _this.state.open, onBlur: child.props.hideOnBlur ? _this.handleOnBlur : null }));
                }
                else {
                    return React.cloneElement(child, __assign({}, child.props));
                }
            }
            return null;
        });
        return (React.createElement(Container, __assign({ tabIndex: 1, ref: this.dropdownRef }, this.props), children));
    };
    Dropdown.prototype.toggleDropdownMenu = function () {
        this.setState({ open: !this.state.open });
    };
    Dropdown.prototype.handleOnBlur = function () {
        var activeElement = document.activeElement;
        this.setState({ open: this.dropdownRef === activeElement });
    };
    return Dropdown;
}(React.Component));
exports.Dropdown = Dropdown;
var templateObject_1, templateObject_2;
